export enum ViewFromEnum {
  INBOX = 'inbox',
  EMAIL = 'email'
}
